import { Alert, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import dayjs from 'dayjs';

type FeedDelayMessageProps = {
  providerName: string;
  lastSync: string | null;
};

function getHoursSinceSync(lastSync: string | null): number | null {
  if (!lastSync) return null;
  return dayjs().diff(dayjs(lastSync), 'hour');
}

export default function FeedDelayMessage({ providerName, lastSync }: FeedDelayMessageProps) {
  const hours = getHoursSinceSync(lastSync);
  const timeText = hours !== null ? ` in ${hours} hours` : '';

  return (
    <Alert icon={<IconInfoCircle />} color="yellow">
      <Text size="sm">
        Valuations for {providerName} accounts have not refreshed{timeText}. We are monitoring the
        connection. No action required from you at this time.
      </Text>
    </Alert>
  );
}
